import styled from 'styled-components'
// import resiLogo from '../images/residence/TL_Res.png'

export const ResiLogo = styled.img `
  width:50vh;
  height: 50vh;
  @media (max-width: 1000px) {
    width: 80vw;
    height: 80vw;
    max-width: 50vh;
    max-height: 50vh;
  }
`

const lightGold = '#e3c791'
const darkGold = '#ba9657'

export const GoldenBg = styled.div `
    height: 100%;
    display: table-cell;
    padding-top: 150px;
    padding-bottom: 150px;
    display: block;
    background: ${lightGold}; /* For browsers that do not support gradients */
    background: -webkit-linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* For Safari 5.1 to 6.0 */
    background: -o-linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* For Opera 11.1 to 12.0 */
    background: -moz-linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* For Firefox 3.6 to 15 */
    background: linear-gradient(to right bottom, ${lightGold}, ${darkGold}); /* Standard syntax */
`



// WEBPACK FOOTER //
// /src/pages/ResidenceStyle.js